import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import { Component_EditorHeader } from '@app/styles';
import { Page_ContextRulesManager } from '../Page_ContextRulesManager.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import './Component_ContextRuleEntityEditor.scss';
import { Component_ContextRules } from '../../../_enum.js';
export class Component_ContextRuleEntityEditor extends TS_EditableItemComponentProto {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = !state.editable.item._id ? true : (this.state?.editMode ?? false);
        return state;
    }
    getMode = () => {
        return this.state.editMode ? 'edit' : 'view';
    };
    getMenuItems = () => {
        return [
            {
                label: 'Edit Context Rule',
                action: async () => this.setState({ editMode: true }),
            }, {
                label: 'Delete Context Rule',
                action: async () => {
                    await this.state.editable.delete();
                    this.props.deselect();
                }
            }
        ];
    };
    getEditModeActions = () => {
        //Actions for existing item
        if (this.state.editable.item._id)
            return [{
                    label: 'Done',
                    action: async () => this.setState({ editMode: false }),
                }];
        //Actions for new item
        return [{
                label: 'Cancel',
                action: async () => {
                    return this.props.deselect();
                },
            }, {
                label: 'Save',
                action: async () => {
                    await this.state.editable.save();
                },
            }];
    };
    renderLabelEditor = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getMode(), modes: [
                    {
                        key: 'view',
                        renderer: () => _jsx(_Fragment, { children: this.state.editable.item.label ?? '-' })
                    },
                    {
                        key: 'edit',
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: this.state.editable, prop: 'label' })
                    }
                ] }) });
    };
    renderDescriptionEditor = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Description', children: _jsx(Component_SwitchView, { mode: this.getMode(), modes: [
                    {
                        key: 'view',
                        renderer: () => _jsx(_Fragment, { children: this.state.editable.item.description ?? '-' })
                    },
                    {
                        key: 'edit',
                        renderer: () => _jsx(TS_TextAreaV2, { type: 'text', onChange: (value) => this.state.editable.updateObj({ description: value }) })
                    }
                ] }) });
    };
    renderRulesEditor = () => {
        const editableRules = this.state.editable.editProp('rules', []);
        const editableExcludedVariables = this.state.editable.editProp('excludedVariableIds', []);
        return _jsx(Component_ContextRules, { editableContextRules: editableRules, editMode: this.state.editMode, editableExcludedVariables: editableExcludedVariables });
    };
    renderHeader = () => {
        return _jsx(Component_EditorHeader, { editable: this.state.editable, editMode: this.state.editMode, itemActions: this.getMenuItems(), editModeActions: this.getEditModeActions(), searchItem: Page_ContextRulesManager.SearchableItem_ContextRules });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'context-rule-entity-editor', children: [this.renderHeader(), _jsxs(LL_V_L, { className: 'context-rule-entity-editor__body', children: [this.renderLabelEditor(), this.renderDescriptionEditor(), this.renderRulesEditor()] })] });
    }
}
//# sourceMappingURL=Component_ContextRuleEntityEditor.js.map